import { PaginationOptions } from '../interfaces/pagination-options.interface';

export const defaultPaginationOptions: PaginationOptions = {
    pageSize: 12,
    pageIndex: 0,
};
